import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=3d024c62&scoped=true"
import script from "./Property.vue?vue&type=script&lang=js"
export * from "./Property.vue?vue&type=script&lang=js"
import style0 from "./Property.vue?vue&type=style&index=0&id=3d024c62&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d024c62",
  null
  
)

export default component.exports